import Host, { colorHostStatus } from "@interfaces/device/host"
import { useTranslation } from "react-i18next"

export type HostState = 'initial' | 'startingTest' | 'success' | 'timeOut'
type HostItemStatusProps = {
  host: Host
  hostState: HostState
  showDevices: () => void
  tryConexion: () => void
}

const HostItemStatus = (props: HostItemStatusProps) => {
  const { t } = useTranslation(['myDevices'])

  const getClassColorHostStatus = (status: HostState) => {
    return colorHostStatus.find((color) => color.name === status)?.value ?? ''
  } 

  return (
    <div className="Devices__HostItemStatus">
      <div className="Devices__HostStatusItem1">
        <div className={`Icon__TextContainer ${getClassColorHostStatus(props.hostState)} `} onClick={props.hostState === 'initial' ? props.tryConexion : undefined}>
          {props.hostState === 'timeOut' ? <em className='fa fa-triangle-exclamation'></em> : null}
          <p>{t(`host.conexion.status.${props.hostState}`)}</p>
          {
            props.hostState === 'initial' ? <em className='fas fa-wifi'></em>
            : props.hostState === 'startingTest' ? "..." 
            : props.hostState === 'success' ? <em className='fa fa-check-circle'></em>
            : null
          }
        </div>
        {props.hostState === 'timeOut' ?
          <div className="Icon__TextContainer Active" onClick={() => props.tryConexion()}>
            <p>{t('host.conexion.retry')}</p>
            <em className='fa fa-arrow-rotate-right'></em>
          </div>:null
        }
      </div>
      <div className="Devices__HostStatusItem2" onClick={() => props.showDevices()}>
        <div className="Icon__TextContainer Active">
          <p>{t('buttons.showRelatedDevices')}</p> 
          <em className='fa fa-monitor-waveform'></em>
        </div>
      </div>
    </div>
  )
}
export default HostItemStatus
